import { reportTelemetryError } from "../../../telemetry";
import { forceReload } from "../../../utils/nativeUtils/customActions";

export const reportError = (error: Error, info: unknown) => {
  console.error("reportError", error.name, error.message, error.stack, info);
  reportTelemetryError(error, {
    errorInfo: typeof info === "string" ? info : JSON.stringify(info)
  });
};

export const resetAfterError = () => {
  forceReload();
};
